import { i18n } from "../../i18n/i18n";

import React, { Component } from 'react'
import { connect, ConnectedProps } from 'react-redux'
import { RootState } from '../../store'
import imageService from '../../services/image.service'
import {
  Element,
  addImageElement,
  addTextElement,
  addBarcodeElement,
  addLineElement,
  addCircleElement,
  addRectElement,
  addEllipseElement,
  addWedgeElement,
  addRingElement,
  addArcElement,
  addArrowElement
} from '../../views/LabelBuilder/LabelBuilder.slice'
import sampleImage from '../../assets/label-sample-image.png'
import barcodePlaceholderImage from '../../assets/label-barcode-placeholder.png'

import imageSvg from '../../assets/image.svg'
import textSvg from '../../assets/text.svg'
import barcodeSvg from '../../assets/barcode.svg'
import lineSvg from '../../assets/line.svg'
import circleSvg from '../../assets/circle.svg'
import rectSvg from '../../assets/rect.svg'
import ellipseSvg from '../../assets/ellipse.svg'
import wedgeSvg from '../../assets/wedge.svg'
import ringSvg from '../../assets/ring.svg'
import arcSvg from '../../assets/arc.svg'
import arrowSvg from '../../assets/arrow.svg'
import Card from '../Card'
import Heading from '../Heading'

interface Props {}

type CombinedProps = Props & ConnectedProps<typeof connector>

class ElementPicker extends Component<CombinedProps> {
  titles: Record<Element['type'], string> = {
    image: 'Image',
    text: 'Text',
    barcode: '1D/2D barcode',
    line: 'Line',
    circle: 'Circle',
    rect: 'Rect',
    ellipse: 'Ellipse',
    wedge: 'Wedge',
    ring: 'Ring',
    arc: 'Arc',
    arrow: 'Arrow'
  }

  handleAddClick = (type: Element['type']) => {
    switch (type) {
      case 'image': {
        imageService.generateImage(sampleImage, (image) => {
          this.props.addImageElement(image)
        })
        break
      }
      case 'text': {
        this.props.addTextElement()
        break
      }
      case 'barcode': {
        imageService.generateImage(barcodePlaceholderImage, (image) => {
          this.props.addBarcodeElement(image)
        })
        break
      }
      case 'line': {
        this.props.addLineElement()
        break
      }
      case 'circle': {
        this.props.addCircleElement()
        break
      }
      case 'rect': {
        this.props.addRectElement()
        break
      }
      case 'ellipse': {
        this.props.addEllipseElement()
        break
      }
      case 'wedge': {
        this.props.addWedgeElement()
        break
      }
      case 'arc': {
        this.props.addArcElement()
        break
      }
      case 'ring': {
        this.props.addRingElement()
        break
      }
      case 'arrow': {
        this.props.addArrowElement()
        break
      }
    }
  }

  iconMap: Record<Element['type'], string> = {
    'image': imageSvg,
    'text': textSvg,
    'barcode': barcodeSvg,
    'line': lineSvg,
    'circle': circleSvg,
    'rect': rectSvg,
    'ellipse': ellipseSvg,
    'wedge': wedgeSvg,
    'ring': ringSvg,
    'arc': arcSvg,
    'arrow': arrowSvg,
  };

  

  element (type: Element['type']) {
    const selectedIcon = this.iconMap[type] || imageSvg;

    return (

      <Card background="darker" flat={true}>
        <div className='justify-center items-center cursor-pointer text-center' style={{
                width: '100%',
                height: '100%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }} onClick={() => this.handleAddClick(type)}>
        <img src={selectedIcon} alt={type} width={50} height={50}/>
        </div>
      </Card>




    )
  }

  render () {
    return (
      <div className='mb-4'>
        <Heading
          className="mb-2"
          text={i18n("Elements")}
          size="small" />
        <div className="grid grid-cols-3 gap-4">
          {this.element('image')}
          {this.element('text')}
          {this.element('barcode')}
          {this.element('line')}
          {this.element('circle')}
          {this.element('rect')}
          {this.element('ellipse')}
          {this.element('wedge')}
          {this.element('ring')}
          {this.element('arc')}
          {this.element('arrow')}
        </div>
      </div>
    )
  }
}

function mapStateTopProps (state: RootState, props: Props) {
  return {}
}

const mapDispatchToProps = {
  addImageElement,
  addTextElement,
  addBarcodeElement,
  addLineElement,
  addCircleElement,
  addRectElement,
  addEllipseElement,
  addWedgeElement,
  addRingElement,
  addArcElement,
  addArrowElement
}

const connector = connect(mapStateTopProps, mapDispatchToProps)
export default connector(ElementPicker)
